import { useCallback, useMemo } from "react";

import { useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { useToast } from "./useToast";

// TODO:
// onError: (error) => {
//   toast({
//     title: "Ошибка!",
//     variant: "destructive",
//     description: (error.response?.data as any)?.message || "",
//   });
// },

export interface useToastNotificationsProps {
  toast?: {
    success?: { title?: string; description?: string };
    error?: { title?: string; description?: string };
  };
  refetchQueries?: string[] | string[][];
}

export const useToastNotifications = ({
  toast,
  refetchQueries,
}: useToastNotificationsProps = {}): {
  onSuccess: () => void;
  onError: (error: AxiosError) => void;
} => {
  const { toast: toastFn } = useToast();
  const queryClient = useQueryClient();

  const onSuccess = useCallback(() => {
    const title = toast?.success?.title || "Удачно!";
    const description = toast?.success?.description || "Данные обновлены.";

    toastFn({
      title: title,
      description: description,
    });

    if (refetchQueries) {
      if (refetchQueries.every((value) => Array.isArray(value))) {
        refetchQueries.forEach((query) => {
          queryClient.refetchQueries({ queryKey: query });
        });
      } else queryClient.refetchQueries({ queryKey: refetchQueries });
    }
  }, [toast, refetchQueries, toastFn, queryClient]);

  const onError = useCallback(
    (error: AxiosError) => {
      const title = toast?.error?.title || "Ошибка!";
      const description =
        toast?.error?.description ||
        (error.response?.data as any)?.message ||
        "Что-то пошло не так.";

      toastFn({
        title: title,
        variant: "destructive",
        description: description,
      });
    },
    [toast, toastFn],
  );

  const result = useMemo(() => ({ onSuccess, onError }), [onSuccess, onError]);

  return result;
};
